import { useState } from "react";
import { ProxiedSignInPage } from '@backstage/core-components';
import { Button, TextField } from '@material-ui/core';

const STORAGE_KEY = 'localproxy.basicAuth'; // base64("user:pass")

function getStoredBasic(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function setStoredBasic(basic: string) {
  try {
    window.localStorage.setItem(STORAGE_KEY, basic);
  } catch {
    // ignore
  }
}

function clearStoredBasic() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export default function LocalBasicAuthSignInPage(props: any) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [storedBasic, setStoredBasicState] = useState<string | null>(() =>
    getStoredBasic(),
  );
  const [error, setError] = useState<string | null>(null);

  if (storedBasic) {
    return (
      <div>
        <div style={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
          <Button
            variant="outlined"
            onClick={() => {
              clearStoredBasic();
              setStoredBasicState(null);
            }}
          >
            Switch user
          </Button>
        </div>

        <ProxiedSignInPage
          {...props}
          provider="localproxy"
          headers={() => ({
            Authorization: `Basic ${storedBasic}`,
          })}
        />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 360, margin: '96px auto', padding: 24 }}>
      <h2>Sign in</h2>

      <form
        onSubmit={e => {
          e.preventDefault();
          setError(null);

          if (!username || !password) {
            setError('Please enter username and password.');
            return;
          }

          // Persist for refreshes (dev-only approach)
          const basic = btoa(`${username}:${password}`);
          setStoredBasic(basic);
          setStoredBasicState(basic);
        }}
      >
        <div style={{ display: 'grid', gap: 12 }}>
          <TextField
            label="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoComplete="username"
            required
            fullWidth
          />

          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            fullWidth
          />

          {error ? <div style={{ color: 'crimson' }}>{error}</div> : null}

          <Button type="submit" variant="contained" color="primary">
            Sign in
          </Button>
        </div>
      </form>
    </div>
  );
}
